import { render, staticRenderFns } from "./_.vue?vue&type=template&id=210d7770&scoped=true"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d7770",
  null
  
)

export default component.exports